const navItems = [
  { label: "Features", href: "#features" },
  { label: "Use Cases", href: "#use-cases" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export function Header() {
  return (
    <header className="site-header">
      <div className="site-nav">
        <a href="#top" className="site-logo" aria-label="PulsePanels home">
          <img
            src="/brand/01_primary_horizontal_logo_transparent.svg"
            alt="PulsePanels"
          />
        </a>

        <nav className="site-nav-links" aria-label="Primary navigation">
          {navItems.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="site-actions">
          <a href="https://app.pulsepanels.com" className="btn-secondary-light site-login">
            Login
          </a>
          <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20demo" className="btn-primary">
            Book a Demo
          </a>
        </div>
      </div>
      <nav className="site-mobile-nav" aria-label="Mobile navigation">
        {navItems.map((item) => (
          <a key={item.href} href={item.href}>
            {item.label}
          </a>
        ))}
        <a href="https://app.pulsepanels.com">Login</a>
      </nav>
    </header>
  );
}
